// ===== IMPORTS ==========================
// The import syntax below is Slate specific and tells Gulp, or whatever build tools Slate V0 runs behind the hood, to concat the listed files into this one.

// SIZE-GUIDE
$(document).ready(() => {

  // tabs functionality
  const tabs = document.querySelectorAll('.size-chart-modal-tab')
  
  tabs.forEach(tab => {
      tab.addEventListener('click', (e) => {
  
          let target = ''
          if (e.target.classList.contains('size-chart-modal-tab-text')) {
              target = e.target.parentNode
          } else {
              target = e.target
          }
  
          if (!(target.classList.contains('active'))) {
              // switch active tab
              const activeTab = document.querySelector('.size-chart-modal-tab.active')
              activeTab.classList.remove('active')
              target.classList.add('active')

              // switch visible content
              const tabAttr = target.getAttribute('data-tab')
              const activeContentBlock = document.querySelector('.size-chart-modal-content-block.active')
              activeContentBlock.classList.remove('active')
              const newActiveContentBlock = document.querySelector(`.size-chart-modal-content-block[data-content='${tabAttr}']`)
              newActiveContentBlock.classList.add('active')
          }
      })
  })

  // toogle imperial/metric
  const toggleButton = document.querySelectorAll('.size-chart-modal-convert-toggle-inner')

  toggleButton.forEach(btn => {
    btn.addEventListener('click', (e) => {
        const activeChart = document.querySelector(".size-chart-modal-content-chart.active")
        const inactiveChart = document.querySelector(".size-chart-modal-content-chart:not(.active)")
        activeChart.classList.remove('active')
        inactiveChart.classList.add('active')
    
        const activeToggle = document.querySelector('.size-chart-modal-convert-toggle-inner.active')
        const inactiveToggle = document.querySelector('.size-chart-modal-convert-toggle-inner:not(.active)')
        activeToggle.classList.remove('active')
        inactiveToggle.classList.add('active')
      })
  })
})